export const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';
export const MEDIA_URL = process.env.REACT_APP_MEDIA_URL || 'http://localhost:8000';

export const ROLES = {
  ADMIN: 'admin',
  PUBLISHER: 'publisher',
  END_USER: 'end_user',
};

export const UPLOAD_SOURCES = {
  SELF: 'SELF',
  ADMIN: 'ADMIN',
  EXCEL: 'EXCEL',
};

export const LANGUAGES = [
  'English', 'Hindi', 'Tamil', 'Telugu', 'Malayalam',
  'Kannada', 'Bengali', 'Marathi', 'Gujarati', 'Punjabi', 'Urdu', 'Other',
];

export const TARGET_SEGMENTS = [
  'Children', 'Young Adults', 'Adults', 'Academic', 'Professional', 'General',
];

export const GENRES = [
  'Fiction', 'Non-Fiction', 'Mystery', 'Thriller', 'Romance', 'Science Fiction',
  'Fantasy', 'Horror', 'Biography', 'Autobiography', 'History', 'Science',
  'Self-Help', 'Business', 'Academic', 'Children', 'Poetry', 'Drama',
  'Short Stories', 'Dystopian Fiction', 'Classic', 'Other',
];

export const LANGUAGE_ORIGINS = ['Original', 'Translated'];

export const TARGET_SEGMENTS_LIQVID = [
  'KG-2', 'Grade 3-5', 'Grade 6-8', 'Grade 9-12',
  'College', 'Higher Education', 'Professional', 'General',
];

export const PAGE_SIZE_OPTIONS = [10, 25, 50, 100];
